import $ from "jquery";
import BD_Component from "@bd-core/bd-component";
import compile from "@bd-utils/handlerbars-helper";
import GameLogic from "@bd-core/game-logic";

export class ManagerPage extends BD_Component {
    constructor() {
        super();

        this.id = "manager-page";
        this.template = "manager-page-template";

        this.elms = {
            app: ".app",
            managerPage: ".manager-page",
            backButton: ".manager-page__back-button",
        };

        this.classes = {};

        this._events = this.getEvents();
    }

    getEvents() {
        const elms = this.elms;
        return [
            {
                selector: elms.backButton,
                event: "click",
                handler: this.handleBackButtonClick,
            },
        ];
    }

    beforeInit() {
        this.render();
        this.setGameState();
    }

    render() {
        const data = this._data;

        const htmlTemplate = $("#" + this.template).html();
        const html = compile(htmlTemplate, data);
        $(this.elms.app).html(html);
    }

    setGameState() {}

    beforeDestroy() {}

    // ===== HANDLERS =====
    handleBackButtonClick(e) {
        e.preventDefault();
        GameLogic.goToPage("home-page");
    }
}
